var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 30,
    viewBox: "0 0 29 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5467 0.638672H1.75984C1.13969 0.638672 0.638672 1.15896 0.638672 1.80296V28.5816C0.638672 29.2256 1.13969 29.7459 1.75984 29.7459H27.5467C28.1669 29.7459 28.6679 29.2256 28.6679 28.5816V1.80296C28.6679 1.15896 28.1669 0.638672 27.5467 0.638672ZM24.3093 9.13435H22.0705C20.3152 9.13435 19.9753 10.0003 19.9753 11.2737V14.0789H24.1657L23.6191 18.4705H19.9753V29.7459H15.6063V18.4741H11.952V14.0789H15.6063V10.8408C15.6063 7.08229 17.8171 5.03387 21.0474 5.03387C22.5961 5.03387 23.9239 5.15393 24.3128 5.20851V9.13435H24.3093Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.f556b19d1a7effae275c5ed761abb236.svg";
export { ForwardRef as ReactComponent };